export default Object.freeze({
  Login: 1,
  Logout: 2,
  RefreshCredentials: 3,
});
